export default "__VITE_ASSET__5ae614b4__"